const defaultBusinessHour = {
  day: 1,
  is_open: false,
  is_continuous_day: false,
  morning_start: '08:00',
  morning_end: '13:00',
  afternoon_start: '15:30',
  afternoon_end: '19:00',
};

const defaultBusinessHours = [1, 2, 3, 4, 5, 6, 7].map((number) => {
  return {
    ...defaultBusinessHour,
    day: number,
  };
});

export default defaultBusinessHours;



// WEBPACK FOOTER //
// ./src/constants/defaultBusinessHours.js